import "./../assets/css/fontawesome.css";
import "./../assets/css/templatemo-finance-business.css";
import "./../assets/css/owl.css";
import React, {useState} from "react";
import Carousel from 'react-bootstrap/Carousel';
import { HomeComponentMessages } from "./HomeComponentMessages";
import {Link} from "react-router-dom";

import MoreInfoImg from './../assets/images/more-info.jpg';



const BannerComponent = props => {

    return(
       <>
        <div class="main-banner header-text" id="top">
            <Carousel>
                <Carousel.Item interval={15000}>
                    <div class="Modern-Slider">
                        <div class="item item-1">
                            <div class="img-fill">
                                <div class="text-content">
                                <h6>a technology partner</h6>
                                <h4>Roots in the Willamette Valley</h4>
                                <p>Wine App Development  Inc is creating technology solutions for the wine industry.  With partners big and small, our solutions are built to be responsive to the needs of our community.</p>
                                <a href="contact.html" class="filled-button">contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={15000}>
                    <div class="Modern-Slider">
                        <div class="item item-2">
                            <div class="img-fill">
                                <div class="text-content">
                                <h6>a technology partner</h6>
                                <h4>Scheduling</h4>
                                <p>Be free from the constraints and high costs imposed by big faceless corporations.  Our platform seamlessly integrates with your website.</p>
                                <Link to="/Services" class="filled-button">our services</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={15000}>
                    <div class="Modern-Slider">
                        <div class="item item-3">
                            <div class="img-fill">
                                <div class="text-content">
                                <h6>a technology partner</h6>
                                <h4>Customer Experience</h4>
                                <p>As our consortium of wineries grows, be able to offer unique experiences to you club membership.</p>
                                <a href="/About" class="filled-button">learn more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
            </Carousel>
        </div>
       </>
    );
}

BannerComponent.defaultProps = {

}
BannerComponent.propTypes = {

}

const WhoWeAreComponent = props => {

    return(
       <>
        <div class="more-info">
            <div class="container">
                <div class="row">
                <div class="col-md-12">
                    <div class="more-info-content">
                    <div class="row">
                        <div class="col-md-6">
                        <div class="left-image">
                            <img src={MoreInfoImg} alt=""/>
                        </div>
                        </div>
                        <div class="col-md-6 align-self-center">
                        <div class="right-content">
                            <span>Who we are</span>
                            <h2>Get to know about <em>our company</em></h2>
                            <p>Darryl and Mark have been wine lovers in the Willamette Valley for almost as long as they've been working in technology. As they put the corporate world behind them, they're looking to combine their passions of local wine and software development.</p>
                            <a href="contact.html" class="filled-button">contact us</a>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <br></br>
       </>
    );
}

WhoWeAreComponent.defaultProps = {

}
WhoWeAreComponent.propTypes = {

}

const HomeComponent = props => {

    return(
       <>
        <BannerComponent/>
        <WhoWeAreComponent/>
       </>


    );
}

HomeComponent.defaultProps = {

}
HomeComponent.propTypes = {

}

export default (HomeComponent);